
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{staticClass:"color",attrs:{"width":"40","height":"28","rx":"1","fill":"#A3A3A3"}}),_c('path',{attrs:{"d":"M27.55 13.74a.3.3 0 010 .52l-12.6 7.274a.3.3 0 01-.45-.26V6.726a.3.3 0 01.45-.26l12.6 7.275z","fill":"#EDEDED"}})])
          )
        }
      }
    